import { Component } from '@angular/core';

@Component({
	selector: 'mb-family-latest-holdings-skeleton',
	templateUrl: './family-latest-holdings-skeleton.component.html',
	styleUrls: ['./family-latest-holdings-skeleton.component.scss']
})
export class FamilyLatestHoldingsSkeletonComponent {
	public GHOST_COLUMNS = Array(10).fill(0);
	public GHOST_ROWS = Array(4).fill(0);
}
